export const BalanceHours = {
  "Saldo total acumulado": "Total accumulated balance",
  "Saldo de horas no período acumulado": "Hours balance in the accumulated period",
  "Data": "Date",
  "Horas necessárias": "Hours required",
  "Horas trabalhadas": "Hours worked",
  "Saldo": "Balance",
  "Pode conter fatores multiplicações nas horas extras aplicadas. Qualquer dúvida, verifique com seu gestor.": "May contain multiplication factors in applied overtime. If you have any questions, check with your manager.",
  "Saldo de horas": "Hours balance",
  "Últimos 30 dias": "Last 30 days",
  "tooltip_update": "The last data update was made on {date}. To update again, click here."
};


// WEBPACK FOOTER //
// ./src/resources/enUS/BalanceHours.js